export default {

  data() {

    return {
      url:{
        menuUrl: SZH.assets.api + "/ClientsData/GetClientsDataJson",
      },
      menus:[],
      fullscreenLoading:false

    }
  },
  methods: {
    ToMemberCenter(){
      let self = this;
      self.$router.push({
        path:'/My/userInfo'
      });
    },
    jumpIn(item){
      let self = this;
      self.$router.push({
        path:item.path
      });
    },
    getMenus(){
      var self = this;
      self.fullscreenLoading = true;
      self.$http.get(self.url.menuUrl,{}).then(result => {
        let menusA = JSON.parse(result.authorizeMenu);
        let menusB = menusA?menusA[0]:[];
        if(menusB.ChildNodes && menusB.ChildNodes.length>0){
          menusB.ChildNodes.forEach(item=>{
            if(item.F_EnCode == 'WHP-Transcompany'){
              item.F_Icon = '/static/images/HomeTH/city.png';
              item.path = '/My/TransportationCompany';
            }
            if(item.F_EnCode == 'WHP-Truck'){
              item.F_Icon = '/static/images/HomeTH/zc.png';
              item.path = '/My/Tractor';
            }
            if(item.F_EnCode == 'WHP-TruckCan'){
              item.F_Icon = '/static/images/HomeTH/gc.png';
              item.path = '/My/Trailer';
            }
            if(item.F_EnCode == 'WHP-Driver'){
              item.F_Icon = '/static/images/HomeTH/sj.png';
              item.path = '/My/Driver';
            }
            if(item.F_EnCode == 'WHP-SuperCargo'){
              item.F_Icon = '/static/images/HomeTH/yyy.png';
              item.path = '/My/Escort';
            }
          });
          self.menus = menusB.ChildNodes;
        }
        self.fullscreenLoading = false;
      },() => {
        self.fullscreenLoading = false;
      });
    }

  },
  created() {
  },
  mounted() {
    this.getMenus();
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/views/Me/HazardousChemicalsEntry/HazardousChemicalsEntry.js